<template>
	<div class="tagForm tra" :class="{ 'bd-dashed-bottom': splitLine }" :mode="option.mode">
		<div
			class="title boxR tra fSub hover-f-main"
			:class="{ dotTitle: splitLine }"
			:title="$t('cmd108', ['点击展开/收起'])"
			ref="tagFormTitle"
			@click="modeChange($event)"
		>
			<div class="name cb">
				<span class="fsLv3">
					{{ title }}
					<slot name="title"></slot>
				</span>
				<span class="arrow cMain fR" v-if="!isShow"
					>{{ $t("app7", ["收起"]) }}
					<button :title="$t('app7', ['收起'])" type="button" class="ml05x vaT">
						<Icon name="arrow-u" class="tra w2x h2x fMain dpIB vaM_E" /><!-- fa fa-caret-down-->
					</button>
				</span>
				<span class="arrow cMain fR" v-else
					>{{ $t("app9", ["展开"]) }}
					<button :title="$t('app9', ['展开'])" type="button" class="ml05x vaT">
						<Icon name="arrow-d" class="tra w2x h2x fMain dpIB vaM_E" /><!-- fa fa-caret-down-->
					</button>
				</span>
				<div class="tool fR mr2x">
					<slot name="titleTool"></slot>
				</div>
				<!-- <span class='fR'>{{$t('app9',['展开'])}}</span> -->
			</div>
			<div class="cSub mt05x" v-if="titleDesc">{{ titleDesc }}</div>
		</div>
		<div class="content">
			<Loading :status="'false'"></Loading>
			<ul v-if="ctrlBtn" class="modeCtrl tra-fast_E">
				<li class="groupView tra-fast_E">
					<button class="edit cMain">{{ $t("cmd8", ["编辑"]) }}</button>
				</li>
				<li class="groupEdit tra-fast_E">
					<button class="cancel cSub">{{ $t("cmd85", ["取消"]) }}</button>
					<button class="save cDanger">{{ $t("cmd84", ["保存"]) }}</button>
				</li>
			</ul>
			<div class="changeGroup tra tra_E">
				<!-- :class="{mt1x:ctrlBtn==false}"-->
				<div class="content-view">
					<slot></slot>
				</div>
				<div class="content-edit">
					<slot name="edit"></slot>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { formModeChange } from "@/util/lib.js";
export default {
	name: "",
	components: {},
	props: {
		title: {
			type: String,
			default: "",
		},
		titleDesc: {
			type: String,
		},
		mode: {
			//默认展示形式:def,min
			type: String,
			default: "def",
		},
		ctrlBtn: {
			// 是否显示编辑状态转换按钮
			type: Boolean,
			default: false,
		},
		showDetail: {
			//已弃用，改用mode传参 是否显示详情
			type: Boolean,
			default: true,
		},
		splitLine: {
			//是否显示下方的间隔线
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			option: {
				mode: this.mode,
			},
			isShow: this.mode == "min" ? true : false,
		};
	},
	watch: {
		mode: function (val) {
			this.option.mode = val;
			switch (this.option.mode) {
				case "min":
					$(this.$el).children(".content").css({ display: "none" });
					this.isShow = true;
					break;
				case "def":
					$(this.$el).children(".content").css({ display: "" });
					this.isShow = false;
					break;
			}
		},
	},
	methods: {
		modeChange(e) {
			// 处理详情面板内的分类内容收起和展开以及编辑状态的控制
			let $root = $(e.currentTarget).parents(".tagForm").first();
			let mode = this.option.mode;
			switch (mode) {
				// case "edit":
				// 	break;
				case "min":
					this.$emit("SizeCtrl", "min");
					$root.attr("mode", "def");
					$root
						.children(".content")
						.stop()
						.slideDown(500, "easeInOutExpo", function () {
							$root.children(".content").css("height", ""); // 不清空会残留高度影响内部的高度动画
						});
					this.option.mode = "def";
					this.isShow = false;
					break;
				case "def":
					this.$emit("SizeCtrl", "def");
					$root.attr("mode", "min");
					$root.children(".content").stop().slideUp(500, "easeInOutExpo");
					this.option.mode = "min";
					this.isShow = true;
					break;
			}
		},
	},
	created() {},
	mounted() {
		if (this.showDetail == false) {
			// this.$refs.tagFormTitle.click()
			this.option.mode = "min";
		}
		switch (this.option.mode) {
			case "min":
				$(this.$el).children(".content").css({ display: "none" });
				break;
		}
	},
};
</script>
<style lang="scss" scoped>
.dotTitle {
	padding: {
		top: 1rem;
	}
}
.tagForm {
	.title {
		padding: {
			bottom: 0.5rem;
		}
		cursor: pointer;
	}
	.content {
		padding: {
		}
		position: relative;
		.modeCtrl {
			position: relative;
			height: 3em;
			> * {
				position: absolute;
				top: 0;
				right: 0;
			}
			button {
				padding: {
					right: 1em;
					left: 1em;
				}
				line-height: 3;
			}
			.groupEdit {
				pointer-events: none;
				opacity: 0;
				transform: translateX(100%);
			} //display:none;
		}
		.changeGroup {
			padding: {
				// bottom: 2rem;
			}
			position: relative;
			/*.content-view{@extend %tra;}*/
			.content-edit {
				position: absolute;
				top: 0;
				z-index: 1;
				opacity: 0;
				transform: translateX(100%);
			}
		}
	}
	&[mode="def"],
	&[mode="min"] {
		.modeLinkage {
			input[type="text"] {
				position: relative;
				top: -0.15em;
				height: auto;
				padding: 0;
				pointer-events: none;
				border-color: rgba(#000, 0);
				box-shadow: none;
			}
			&.select {
				top: 0.1em;
				pointer-events: none;
				.selectDisplay {
					padding: {
						left: 0;
					}
					border-color: rgba(#000, 0);
					.fa {
						opacity: 0;
					}
				}
			}
		}
	}
	&[mode="min"] {
		//.title{padding:{bottom:2rem}};
		// .title .arrow{transform:rotate(180deg);}
	}
	&[mode="min"] {
		.dotTitle {
			padding: {
				bottom: 1rem;
			}
		}
		// .title .arrow{transform:rotate(180deg);}
	}
	&[mode="edit"] {
		background-color: rgba($danger, 0.1);
		.title {
			color: #fff;
			cursor: auto;
			background-color: $danger;
		}
		.modeCtrl {
			.groupView {
				pointer-events: none;
				opacity: 0;
				transform: translateX(-200%);
			}
			.groupEdit {
				pointer-events: auto;
				opacity: 1;
				transform: translateX(0);
			}
		}
		.changeGroup {
			.content-view {
				opacity: 0;
				transform: translateX(-100%);
			}
			.content-edit {
				opacity: 1;
				transform: translateX(0);
			}
		}
		.changeGroup {
			.content-view {
				opacity: 0;
				transform: translateX(-100%);
			}
			.content-edit {
				opacity: 1;
				transform: translateX(0);
			}
		}
	}
	table th,
	.table-colType1 th {
		width: 15%;
	}
	table th,
	.table-colType1 th {
		width: 15%;
	}
}
.content {
	max-height: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/TagForm.vue